import { useRef, useState } from "react";
import { Paperclip, X } from "lucide-react";

export const MAX_FILES = 5;
const MAX_BYTES = 5 * 1024 * 1024;
const ACCEPT = ".jpg,.jpeg,.png,.gif,.webp,.heic,.pdf,.doc,.docx,.txt,.xls,.xlsx,.ppt,.pptx,.csv,.zip,.mp3,.mp4,.mov";
const size = (b) => (b > 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

export const FileDrop = ({ files, setFiles, onError }) => {
  const input = useRef(null);
  const [over, setOver] = useState(false);

  const add = (list) => {
    const picked = Array.from(list || []);
    const big = picked.find((f) => f.size > MAX_BYTES);
    if (big) onError(`${big.name} is larger than 5 MB.`);
    const next = [...files, ...picked.filter((f) => f.size <= MAX_BYTES)];
    if (next.length > MAX_FILES) onError(`You can attach up to ${MAX_FILES} files.`);
    setFiles(next.slice(0, MAX_FILES));
  };

  return (
    <div>
      <button type="button" id="contact-files" data-testid="contact-files-dropzone" onClick={() => input.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)}
        onDrop={(e) => { e.preventDefault(); setOver(false); add(e.dataTransfer.files); }}
        className={`flex w-full items-center gap-3 border border-dashed px-4 py-3 text-left text-[#0A0A0A] transition-colors ${over ? "border-[#FF4A36] bg-[#FF4A36]" : "border-[#FF4A36] bg-white hover:bg-[#FFF1EF]"}`}>
        <Paperclip className="h-4 w-4 shrink-0" />
        <span className="flex-1 text-sm font-bold">Upload files</span>
        <span className="text-xs text-[#57534E]">Max 5 MB each</span>
      </button>
      <input ref={input} type="file" multiple accept={ACCEPT} className="hidden" data-testid="contact-files-input"
        onChange={(e) => { add(e.target.files); e.target.value = ""; }} />
      {files.length > 0 && (
        <ul className="mt-3 flex flex-col gap-2" data-testid="contact-files-list">
          {files.map((f, i) => (
            <li key={`${f.name}-${i}`} className="flex items-center gap-3 bg-[#ECEAE6] px-4 py-2.5 text-sm">
              <span className="min-w-0 flex-1 break-words font-semibold">{f.name}</span>
              <span className="text-[#57534E]">{size(f.size)}</span>
              <button type="button" aria-label={`Remove ${f.name}`} data-testid={`contact-file-remove-${i}`}
                onClick={() => setFiles(files.filter((_, j) => j !== i))} className="transition-colors hover:text-[#E62314]">
                <X className="h-4 w-4" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
